import React from "react";
import { Tab } from "./Tab";


function pageDescription(tabs, step) {
  var actualTab = tabs.find(tab => tab.step === step ? tab : null)
  return actualTab.stepDescription;
}

export const ProgressTab = props => <div className="box p-1 p-sm-2">
  <Tab tabs={props.tabs} open={props.open} actualState={props.actualState} />
  <div>
    <br />
    <h2 className="box-title pb-1 mb-1">
      {props.title}
    </h2>
    <p>{pageDescription(props.tabs, props.actualState.state.step)}</p>

    {props.tabs.map(step => step.stepConditions ? step.stepPage : null)}
  </div>
</div>
